import { render, staticRenderFns } from "./ClientLayout.vue?vue&type=template&id=1da27d85&scoped=true&"
import script from "./ClientLayout.vue?vue&type=script&lang=js&"
export * from "./ClientLayout.vue?vue&type=script&lang=js&"
import style0 from "./ClientLayout.vue?vue&type=style&index=0&id=1da27d85&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1da27d85",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ichigei/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1da27d85')) {
      api.createRecord('1da27d85', component.options)
    } else {
      api.reload('1da27d85', component.options)
    }
    module.hot.accept("./ClientLayout.vue?vue&type=template&id=1da27d85&scoped=true&", function () {
      api.rerender('1da27d85', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/layouts/Client/ClientLayout.vue"
export default component.exports